<template>
  <div class="member">
    <app-loading :visible="loading"/>
    <div class="md-title">
      <div class="nav-content" v-show="showNav">
        <router-link :to="{ name: 'OrganizationListPage', query: { parent_id: this.getQueryPartyOrganizationId() } }">
          {{ organization.shortName }}
        </router-link>
      </div>
    </div>
    <div class="toolbar">
      <md-field class="list-search-field" md-clearable v-on:md-clear="onSearchClear">
          <md-input :placeholder="translate('placeholderMember')"
            v-model="searchTerm"
            type="text"
            class="input-content"
            v-on:keyup.enter="searchMembers">
          </md-input>
        </md-field>
        <div class="button-add-wrp">
          <md-button class="md-icon-button md-raised md-primary search-placing" v-on:click="searchMembers">
            <md-icon>search</md-icon>
          </md-button>
          <md-button v-if="canAdd()" class="md-icon-button md-raised md-primary add-placing" v-on:click="goToAddForm">
            <md-icon>add</md-icon>
          </md-button>
        </div>
    </div>
    <md-table v-model="members" v-show="!loading">
      <md-table-empty-state
        :md-label="nothingWasFound">
      </md-table-empty-state>
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell :md-label="cardNumber">{{ item.cardNumber }}</md-table-cell>
        <md-table-cell :md-label="lastName">{{ item.lastName }}</md-table-cell>
        <md-table-cell :md-label="firstName">{{ item.firstName }}</md-table-cell>
        <md-table-cell :md-label="patronymic">{{ item.patronymic }}</md-table-cell>
        <md-table-cell :md-label="mobilePhoneNumber">{{ item.mobilePhoneNumber }}</md-table-cell>
        <md-table-cell>
          <md-button class="md-icon-button md-raised md-primary"
            :to="{ name: 'MemberFormEditPage', params: { memberId: item.id }, query: getFormQueryParams() }">
            <md-icon>create</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import MemberService from '@/common/services/member'
import OrganizationService from '@/common/services/organization'
import AppLoading from '@/components/ui/AppLoading.vue'
import HasLoading from '@/mixins/HasLoading.mixin'
import HasListFilter from '@/mixins/HasListFilter.mixin'
import Auth from '@//common/auth/index.js'
import debounce from 'debounce'

export default {
  name: 'OrganizationMemberComponent',
  components: {
    AppLoading
  },
  mixins: [
    HasLoading,
    HasListFilter
  ],
  data () {
    return {
      /** @type {Member[]} */
      members: [],
      /** @type {Organization} */
      organization: {},
      canManage: Auth.CanManageMembers(),
      showNav: !this.hasSearchTerm()
    }
  },
  watch: {
    '$route.query.party_organization_id' () {
      this.readMembers()
      this.getOrganization()
    },
    '$route.query.search_term' (val) {
      this.watchSearchTerm(val)
    },
    searchTerm (val, oldValue) {
      if (val === '' && oldValue !== '' && this.appliedSearchTerm) {
        this.showNav = true
      }
    }
  },
  created () {
    this.initTableLabels()

    this.readMembers()
    this.getOrganization()

    this.watchSearchTerm = debounce(this.watchSearchTerm, 300)
  },
  methods: {
    onSearchClear () {
      this.searchTerm = ''
      this.commitSearchTerm()
    },
    watchSearchTerm (val) {
      this.searchTerm = val
      this.readMembers()
    },
    canAdd () {
      return this.canManage && !this.appliedSearchTerm
    },
    initTableLabels () {
      this.cardNumber = this.translate('cardNumber')
      this.firstName = this.translate('firstName')
      this.lastName = this.translate('lastName')
      this.patronymic = this.translate('patronymic')
      this.mobilePhoneNumber = this.translate('mobilePhoneNumber')
      this.nothingWasFound = this.translate('nothingWasFound')
    },
    hasQueryPartyOrganizationId () {
      const organizationId = this.$route.query.party_organization_id
      return organizationId && organizationId !== '0'
    },
    getQueryPartyOrganizationId () {
      return this.$route.query.party_organization_id || process.env.ROOT_PARENT_ID
    },
    hasSearchTerm () {
      return this.$route.query.search_term && this.$route.query.search_term !== ''
    },
    readMembers () {
      this.startAppLoading()

      const orgId = this.getQueryPartyOrganizationId()
      MemberService.Select(orgId, this.searchTerm)
        .then(response => {
          this.members = response.data
        })
        .catch(error => this.$httpError.handle.call(this, error))
        .then(() => {
          this.commitSearchTerm()
          this.finishAppLoading()
        })
    },
    searchMembers () {
      this.commitSearchTerm()

      if (this.searchTerm) {
        this.showNav = false
      }
    },
    getFormQueryParams () {
      const qp = {}

      if (this.hasQueryPartyOrganizationId()) {
        qp.party_organization_id = this.getQueryPartyOrganizationId()
      }

      if (this.appliedSearchTerm) {
        const searchTermKey = this.getQuerySearchTermKey()
        qp[searchTermKey] = this.appliedSearchTerm
      }

      return qp
    },
    goToAddForm () {
      this.$router.push({
        name: 'MemberFormAddPage',
        query: this.getFormQueryParams()
      })
    },
    getOrganization () {
      const organizationId = this.getQueryPartyOrganizationId()
      OrganizationService.Get(organizationId)
        .then(response => {
          this.organization = response.data
        })
        .catch(error => this.$httpError.handle.call(this, error))
    }
  }
}

</script>
<style lang="scss" scoped>
.nav-content {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/members/List.vue